export default "__VITE_ASSET__459767ca__"